export default "__VITE_ASSET__58f46c7f__"